var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import SendButton from "./SendButton";
import ChatInputOptions from "./ChatInputOptions";
import StopButton from "./StopButton";
export const LLMChatInput = ({ waitingResponse, completing, sendMessage, stopAnswer, vss, }) => {
    const [input, setInput] = useState("");
    const [selectedFile, setSelectedFile] = useState(null); // State to hold the selected file
    const [selectedSystem, setSelectedSystem] = useState(null);
    const waiting = waitingResponse || completing;
    const handleSendMessage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!waiting && input.trim()) {
            sendMessage(input, selectedFile, selectedSystem);
            setSelectedFile(null);
            setSelectedSystem(null);
            setInput("");
        }
    });
    const handleStop = () => __awaiter(void 0, void 0, void 0, function* () {
        stopAnswer();
    });
    const handleKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleSendMessage();
        }
    };
    return (_jsx(TextField, { sx: {
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
            overflowX: "auto",
        }, multiline: true, maxRows: 10, variant: "outlined", fullWidth: true, value: input, disabled: waiting, size: "small", onChange: (e) => setInput(e.target.value), onKeyDown: handleKeyDown, placeholder: "Ask anything.", InputProps: {
            sx: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                "& .MuiInputBase-input": {
                    mb: 1,
                },
            },
            endAdornment: (_jsx(Box, Object.assign({ sx: { py: 1, mr: -1 } }, { children: _jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsxs(Box, Object.assign({ sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        } }, { children: [_jsx(ChatInputOptions, { waiting: waiting, initSelectedFile: selectedFile, initSelectedSystem: selectedSystem, setSelectedFileCallback: setSelectedFile, setSelectedSystemCallback: setSelectedSystem, vss: vss }), completing && !waitingResponse ? (_jsx(StopButton, { handleStop: handleStop })) : (_jsx(SendButton, { handleSendMessage: handleSendMessage, waiting: waiting }))] })) })) }))),
            style: {
                color: "white",
                backgroundColor: "#4d4d4d",
                fontSize: "0.8em",
                paddingTop: "12px",
                paddingBottom: "12px",
            },
        } }));
};
